(() => {
  const init = () => {
    const root = document.getElementById('ih-sales-ui');
    const menu = document.getElementById('navigation-mobile');
    const template = root?.querySelector('[data-ih-mobile-menu-sales]');
    if (!menu || !template || menu.querySelector('.ih-mobile-menu-sales')) return;
    const actions = template.content.cloneNode(true);
    const heading = menu.querySelector('.menu-heading-mobile');
    if (heading) heading.after(actions);
    else menu.querySelector('.halo-sidebar-wrapper')?.prepend(actions);
    let returnToggle;
    menu.addEventListener('click', event => {
      if (!event.target.closest('[data-ih-call-store]')) return;
      if (!document.body.classList.contains('menu_open')) return;
      returnToggle = Array.from(document.querySelectorAll('.mobileMenu-toggle')).find(button => button.getBoundingClientRect().width > 0);
      menu.querySelector('[data-menu-close-sidebar]')?.click();
    }, true);
    root.querySelector('#ih-store-dialog')?.addEventListener('close', () => {
      if (!returnToggle) return;
      const toggle = returnToggle;
      returnToggle = null;
      queueMicrotask(() => toggle.focus());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

(() => {
  const initSearchFocus = () => {
    const panel = document.getElementById('search-form-mobile');
    const input = panel?.querySelector('input[type="search"]');
    if (!panel || !input) return;
    let open = false;
    let returnToggle;
    const isOpen = () => document.body.classList.contains('open_search_mobile');
    const visible = element => element.getBoundingClientRect().width > 0 && getComputedStyle(element).visibility !== 'hidden';
    const focusInput = () => {
      if (isOpen() && !panel.contains(document.activeElement)) input.focus({preventScroll: true});
    };
    const sync = () => {
      const nextOpen = isOpen();
      if (nextOpen === open) return;
      open = nextOpen;
      if (open) {
        returnToggle = Array.from(document.querySelectorAll('[data-search-mobile]')).find(visible);
        panel.setAttribute('role', 'dialog');
        panel.setAttribute('aria-modal', 'true');
        panel.setAttribute('aria-label', input.labels?.[0]?.textContent.trim() || input.placeholder);
        requestAnimationFrame(() => {
          if (isOpen()) input.focus({preventScroll: true});
        });
        setTimeout(focusInput, 550);
      } else {
        panel.removeAttribute('aria-modal');
        if (panel.contains(document.activeElement)) returnToggle?.focus({preventScroll: true});
      }
    };
    new MutationObserver(sync).observe(document.body, {attributes: true, attributeFilter: ['class']});
    panel.addEventListener('transitionend', event => {
      if (event.target === panel) focusInput();
    });
    document.addEventListener('focusin', event => {
      if (isOpen() && event.target.matches('[data-search-mobile], #search-form-mobile summary.header__search-full')) input.focus({preventScroll: true});
    }, true);
    document.addEventListener('keydown', event => {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        panel.querySelector('[data-search-close-sidebar]')?.click();
      } else if (event.key === 'Tab') {
        const controls = Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled])')).filter(visible);
        if (!controls.length) return;
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }
    }, true);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSearchFocus, {once: true});
  else initSearchFocus();
})();

(() => {
  const initMenuFocus = () => {
    const panel = document.getElementById('navigation-mobile');
    const close = panel?.querySelector('[data-menu-close-sidebar]');
    if (!panel || !close) return;
    let open = false;
    let returnToggle;
    const isOpen = () => document.body.classList.contains('menu_open');
    const visible = element => element.getBoundingClientRect().width > 0 && getComputedStyle(element).visibility !== 'hidden';
    const controls = () => Array.from(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled])')).filter(visible);
    const sync = () => {
      const nextOpen = isOpen();
      if (nextOpen === open) return;
      open = nextOpen;
      if (open) {
        returnToggle = Array.from(document.querySelectorAll('.mobileMenu-toggle')).find(visible);
        requestAnimationFrame(() => {
          if (isOpen() && !panel.contains(document.activeElement)) close.focus({preventScroll: true});
        });
      } else if (panel.contains(document.activeElement)) {
        returnToggle?.focus({preventScroll: true});
      }
    };
    new MutationObserver(sync).observe(document.body, {attributes: true, attributeFilter: ['class']});
    document.addEventListener('keydown', event => {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        close.click();
      } else if (event.key === 'Tab') {
        const targets = controls();
        if (!targets.length) return;
        const first = targets[0];
        const last = targets[targets.length - 1];
        if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
      }
    }, true);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMenuFocus, {once: true});
  else initMenuFocus();
})();

(() => {
  const initSingleImageGallery = () => {
    if (!document.body.classList.contains('template-product') || !window.jQuery) return;
    window.jQuery(document).on('beforeShow.fb.ihSingleImage', (_event, gallery) => {
      gallery.$refs.container.toggleClass('ih-single-image', gallery.group.length === 1);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSingleImageGallery, {once: true});
  else initSingleImageGallery();
})();
